'use client';

import type { Ref } from 'react';

import classnames from 'classnames';

import type { ThemeToggleButtonProps } from './ThemeToggleButton.types';

import styles from './ThemeToggleButton.module.scss';

export function ThemeToggleButton({
  style,
  className,
  checked = false,
  onToggle,
  label = 'Cambiar tema',
  testId = 'ui-theme-toggle',
  ref,
  ...rest
}: ThemeToggleButtonProps & { ref?: Ref<HTMLInputElement> }) {
  return (
    // The track and the knob are real elements: WebKit does not generate
    // ::before/::after on an <input>, so drawing the switch on the checkbox
    // itself renders nothing (or the native control) on Safari. The input
    // stays on top at full size, so a click still lands on the checkbox and
    // bubbles exactly as it did when it was the only element.
    <span
      style={style}
      className={classnames(styles['theme-toggle'], className)}
    >
      <input
        ref={ref}
        className={styles['input']}
        type="checkbox"
        checked={checked}
        onChange={onToggle}
        aria-label={label}
        data-testid={testId}
        {...rest}
      />
      <span className={styles['track']} aria-hidden="true">
        <span className={styles['knob']} />
      </span>
    </span>
  );
}
